import { useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';

// Merge built-in defaults + persisted custom options (from /api/options/{category})
// + any values already present in existing records. Adding a value persists it
// server-side so it shows up in every future form.
export function useOptionSet(category, defaults = [], extra = []) {
  const [custom, setCustom] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get(`/options/${category}`)
      .then(r => { if (alive) setCustom(Array.isArray(r.data) ? r.data : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [category]);

  const addOption = useCallback(async (value) => {
    const v = (value || '').trim();
    if (!v) return;
    setCustom(prev => (prev.some(x => x.toLowerCase() === v.toLowerCase()) ? prev : [...prev, v]));
    try { await api.post(`/options/${category}`, { value: v }); } catch { /* best-effort */ }
  }, [category]);

  const seen = new Set();
  const options = [];
  [...defaults, ...custom, ...extra].forEach(o => {
    const k = (o || '').trim();
    if (k && !seen.has(k.toLowerCase())) { seen.add(k.toLowerCase()); options.push(k); }
  });
  options.sort((a, b) => a.localeCompare(b));

  return { options, addOption };
}

export default useOptionSet;
